import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=08033c5e&scoped=true&"
import script from "./register-success.vue?vue&type=script&lang=js&"
export * from "./register-success.vue?vue&type=script&lang=js&"
import style0 from "./register-success.vue?vue&type=style&index=0&id=08033c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08033c5e",
  null
  
)

export default component.exports